module.exports = __webpack_public_path__ + "Flag-682.bb21acd6fe7a236258af56c09ca145a6.svg";